<template>
    <div class="container-fluid  pt-2" >

        <div class="container">
            <div v-if="missingdata===true">
                <div class=" h-100 d-flex justify-content-center align-items-center">
                    <div class="text-center mt-5 pt-5">
                        <img src="/images/embarrassed.png" style="width:100px;" class="img-fluid">
                        <h3 class="text-center py-3">Missing Data</h3>
                        <a href="/expenses" class="btn btn-primary" >Reload <i class="bi bi-arrow-repeat"></i></a>
                    </div>
                </div>



            </div>
            <div v-if="missingdata===false">
                <full-cal></full-cal>
            </div>
        </div>
    </div>
</template>
<script>

    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    export default{
        name: 'appointments.vue',
        components: {DateRangePicker},
        data(){
            return {
                missingdata:false,
                expenses:'',
                highestexpenses:'',
                totalexpenses:'',
                userrole:'',

                expensestatus:'',
                expenseform:{
                    expense:'',
                    expense_cat_selected: null,
                    expenseamount:'',
                    expense_cat_options:[]
                },
                searchExpense:'',
                fields: [
                    'index',
                    { key: 'expense', sortable: true },
                    { key: 'amount', sortable: true },
                    { key: 'status', sortable: true },
                    { key: 'created_by', sortable: true },
                    { key: 'created_on', sortable: true }

                ],
                items: [],
                selectedexpense:'',
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                autoApply:true




            }
        },
        mounted(){
            this.GetExpenses();
        },
        watch:{
            searchExpense(before,after)
            {

                this.GetExpenses()
            },
            dateRange(before,after)
            {
                this.GetExpenses()
            }
        },

    }
</script>

<style scoped>

</style>